import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
import User from "@/models/lms/User"
export default class Comment extends GenexLMSModel {
    static entity = 'comments'

    static fields() {
        return {
            id: this.attr(null),
            creator_id: this.attr(null),
            creator: this.belongsTo(User, 'creator_id'),
            body: this.attr(null),
            note_id: this.attr(null)
        }
    }


}